import { useSetRoute } from '@features/app-hooks'
import { authModule } from '@features/auth/auth-module'
import { oneHourCourseRoute, SetAppRoute } from '~/features/routes'
import { useLink } from '@features/use-link'
import { Button, HeaderNav, HeadNavDropdown, HeadNavDropdownLink, HeadNavLink } from '@st/theme'
import { HTMLAttributeAnchorTarget, ReactNode } from 'react'
import { useProcess } from '~/store'

export function STAppHeaderNav() {
  const auth = useProcess('auth')
  const setRoute = useSetRoute()

  return (
    <HeaderNav
      onClickLogo={() => {
        setRoute({ name: 'folder_list' })
      }}
      trailingMenu={
        <Button variant="link" className="text-white" onClick={() => auth.send({ type: 'logout' })}>
          Logout
        </Button>
      }
    >
      <AppHeaderNavLink href={{ name: 'folder_list' }}>Binders</AppHeaderNavLink>
      <AppHeaderNavLink href={{ name: 'team' }}>Settings</AppHeaderNavLink>
      <AppHeaderNavLink href={{ name: 'logged_in_pricing' }}>Pricing</AppHeaderNavLink>
      <AppHeaderNavLink target="_blank" href="https://calendly.com/d/cxgq-mv8-s3j">
        Book Consultation
      </AppHeaderNavLink>

      <HeadNavDropdown title="Resources">
        <HeadNavDropdownLink target="_blank" href="https://stanfordtax.com/book-demo">
          Live Demos
        </HeadNavDropdownLink>
        <HeadNavDropdownLink target="_blank" href={oneHourCourseRoute({})}>
          One-hour Course
        </HeadNavDropdownLink>
        <HeadNavDropdownLink
          target="_blank"
          href="https://stanfordtax.webinargeek.com/office-hours?cst=st-app"
        >
          Office Hours
        </HeadNavDropdownLink>
      </HeadNavDropdown>
    </HeaderNav>
  )
}

function AppHeaderNavLink(props: {
  href: SetAppRoute | string
  children: ReactNode
  onClick?: () => void
  target?: HTMLAttributeAnchorTarget
}) {
  const { href, onClick, isActive } = useLink({ href: props.href })

  return (
    <HeadNavLink href={href} onClick={onClick} active={isActive} target={props.target}>
      {props.children}
    </HeadNavLink>
  )
}
